module.exports = __webpack_public_path__ + "static/img/user8.851e5d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user8.jpg
// module id = ACy6
// module chunks = 23